import { createContext } from 'react';

export type GameCardContextProps = {
  dismissCard: () => void;
};
export const GameCardContext = createContext<GameCardContextProps>({} as GameCardContextProps);
